import { Component, Input, OnInit } from '@angular/core';
import { Observable, Observer, Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: '[submitButton]',
  templateUrl: 'submit-button.component.html'
})
export class SubmitButtonComponent implements OnInit {

  private spinTimeout: number = 1;

  @Input() submitPending: boolean;
  @Input() labelButton: string;
  @Input() disabled: boolean;
  @Input() disableSpinner: boolean;
  public enableObservable: Observable < boolean > ;
  private subscription: Subscription = null;
  private enableObserver: Observer < boolean > ;
  idValue: string;

  constructor() {}

  ngOnInit() {
    // this.createServiceSubscription();
    this.idValue = 'submit_button_' + Math.round(Math.random() * 100000);
  }
  // todo: da controllare
  // private createServiceSubscription() {
  //   this.subscription = this.httpService.enableObservable.subscribe(show => {
  //     if (show) {
  //       this.submitPending = true;
  //     } else {
  //       this.submitPending = false;
  //     }
  //   });
  // }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }


  click(): void {
    this.submitPending = true;
  }

}
